import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// Attach the JWT/session token from localStorage as a Bearer header on every
// request. This is the auth fallback for browsers that aggressively drop
// cross-site cookies (iOS Safari, Brave, Safari Private mode, etc.).
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("cm_token");
  if (token) {
    config.headers = config.headers || {};
    if (!config.headers.Authorization) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  }
  return config;
});

// If a request comes back 401, clear the stale token so the next /me check
// surfaces an unauthenticated state instead of looping.
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      localStorage.removeItem("cm_token");
    }
    return Promise.reject(error);
  },
);

export function fileUrl(storagePath, token) {
  const t = token || localStorage.getItem("cm_token") || "";
  return `${API_BASE}/files/${storagePath}${t ? `?auth=${encodeURIComponent(t)}` : ""}`;
}
